import React from 'react';
import { HeartIcon, InstagramIcon, LinkedinIcon } from '../assets/icons/Icons';
import '../styles/footer.css';

const footerLinks = {
  services: [
    { label: 'Psychiatric evaluation', href: '#services' },
    { label: 'De-addiction', href: '#services' },
    { label: 'Women\'s mental health', href: '#services' },
    { label: 'Child & adolescent', href: '#services' },
    { label: 'Individual therapy', href: '#services' },
    { label: 'Couples & family', href: '#services' },
    { label: 'Teams, professionals, and students', href: '#services' },
  ],
  company: [
    { label: 'About us', href: '/contact' },
    { label: 'Our doctors', href: '#doctors' },
    { label: 'Blog', href: '#' },
    { label: 'Careers', href: '#' },
    { label: 'Contact', href: '#' },
  ],
  support: [
    { label: 'Help center', href: '#' },
    { label: 'Privacy policy', href: '#' },
    { label: 'Terms of service', href: '#' },
    { label: 'Insurance', href: '#' },
    { label: 'Accessibility', href: '#' },
  ],
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">

          {/* Brand Column */}
          <div className="footer-brand">
            <a href="#" className="logo">
              <div className="logo-icon">
                <img
                  src="/ishira-logo.png"
                  alt="Ishira"
                  className="logo-img"
                />
              </div>
              <span className="logo-lockup">
                <span className="logo-text">Ishira</span>
                <span className="logo-tagline">The Mind Clinic</span>
              </span>
            </a>
            <p>
              Compassionate psychiatric care and therapy, designed to meet you
              where you are. Online and in-person.
            </p>
            <div className="footer-social">
              <a
                href="https://www.instagram.com/ishiramind/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="footer-social-link"
              >
                <InstagramIcon size={18} />
              </a>
              <a
                href="https://www.linkedin.com/company/ishira-the-mind-clinic/about/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="footer-social-link"
              >
                <LinkedinIcon size={18} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4>Services</h4>
            <ul>
              {footerLinks.services.map((link, i) => (
                <li key={i}><a href={link.href}>{link.label}</a></li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4>Company</h4>
            <ul>
              {footerLinks.company.map((link, i) => (
                <li key={i}><a href={link.href}>{link.label}</a></li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4>Support</h4>
            <ul>
              {footerLinks.support.map((link, i) => (
                <li key={i}><a href={link.href}>{link.label}</a></li>
              ))}
            </ul>
          </div>

        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Ishira The Mind Clinic. All rights reserved.</p>
          <div className="crisis-line">
            <a href="tel:+919980810632">Contact Us: +91 99 8081 0632</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
